import React from 'react';
import { Breadcrumb as AntBreadcrumb } from 'antd';
import type { BreadcrumbProps } from 'antd';
import { Link, To, useLocation } from 'react-router-dom';

export { Breadcrumb as BaseBreadcrumb } from 'antd';
export type { BreadcrumbProps as BaseBreadcrumbProps } from 'antd';

interface Route {
  path: string;
  breadcrumbName: string;
}

interface BaseBreadcrumbWithRenderProps extends BreadcrumbProps {
  routes?: Route[];
}

interface RouteState extends Route {
  state?: { id?: string };
}

export const BaseBreadcrumbWithRender: React.FC<BaseBreadcrumbWithRenderProps> = ({ routes, itemRender, ...props }) => {
  const defaultItemRender: BreadcrumbProps['itemRender'] = (
    route: RouteState,
    params: any,
    routes: Route[],
    paths: string[],
  ) => {
    const isLast = routes.indexOf(route) === routes.length - 1;

    return isLast ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <Link to={route.path} state={route?.state}>
        {route.breadcrumbName}
      </Link>
    );
  };

  return (
    <AntBreadcrumb
      {...props}
      routes={routes}
      itemRender={itemRender || defaultItemRender}
      separator={props.separator || '>'}
    />
  );
};
